
import { Card } from "@/components/ui/card";

export const MembershipInfo = () => {
  return (
    <>
      <div className="bg-white rounded-lg shadow-md p-6 mb-6">
        <h3 className="text-xl font-semibold mb-4">SPO Membership Cost</h3>
        <p className="text-gray-600 mb-4">
          It is proposed that each member will initially purchase redeemable shares (£1,000), 
          which will be used as capital to establish the organisation.
        </p>
        <p className="text-gray-600 mb-4">
          Members will then pay an annual fee based on their area of seed grown.
        </p>
        <p className="text-gray-600 font-semibold">
          The 2025 annual fee for growers is £800.
        </p>
      </div>

      <div className="bg-white rounded-lg shadow-md p-6">
        <h3 className="text-xl font-semibold mb-4">Who can be an SPO member?</h3>
        <ul className="list-disc list-inside text-gray-600 space-y-2 mb-4">
          <li>Seed growers</li>
          <li>Ware growers</li>
          <li>Potato trade and supply chain companies will be welcome to join as Associate Members.</li>
        </ul>
        <h4 className="font-semibold mb-2">A Democratic Co-Op</h4>
        <p className="text-gray-600 mb-4">
          The basis of control in a co-op is democratic through one member one vote, irrespective 
          of size of business. The principal governing control is equality. Co-ops are based on 
          the values of self-help, honesty, democracy and solidarity.
        </p>
        <h4 className="font-semibold mb-2">Governance</h4>
        <p className="text-gray-600">
          The co-op will be governed by a Board of Directors, whose main purpose is to ensure SPO 
          members' future prosperity and success by collectively directing its affairs. Directors 
          are elected and appointed by the members to represent their interest and ensure the 
          successful guardianship of the organisation.
        </p>
      </div>
    </>
  );
};
